import { z } from 'zod'

/**
 * Get a string query parameter.
 * If missing, return an empty string. Wrapping it in `.optional()` still applies the default;
 * use `qsOptionalStringSchema` to get undefined instead.
 */
export const qsStringSchema = z.coerce.string().optional().default('')

/**
 * Get a string query parameter.
 * If missing, return undefined.
 */
export const qsOptionalStringSchema = z.coerce.string().optional()

/**
 * Get a string query parameter.
 * If missing, return null.
 */
export const qsSchema = z.coerce.string().nullable().optional().default(null)
